import antdSA from 'antd/lib/locale-provider/fr_FR';
import * as appLocaleData  from  'react-intl/locale-data/fr';
import saMessages from '../locales/fr_FR';

const saLang = {
    messages: {
        ...saMessages
    },
    antd: antdSA,
    locale: 'fr-FR',
    data: appLocaleData
};
export default saLang;



// WEBPACK FOOTER //
// ./src/languageProvider/entries/fr_FR.ts